import React, { useState } from 'react';

import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, FloatingTextarea } from '#ui/index.js';

interface BadResponseFeedbackDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (comment: string) => void | Promise<void>;
}

export function BadResponseFeedbackDialog({ open, onOpenChange, onSubmit }: BadResponseFeedbackDialogProps) {
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleOpenChange(nextOpen: boolean) {
    if (!nextOpen && isSubmitting) return;
    onOpenChange(nextOpen);
  }

  async function handleSubmit() {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await onSubmit(comment.trim());
      setComment('');
      onOpenChange(false);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Help us improve this answer</DialogTitle>
        </DialogHeader>
        <FloatingTextarea
          id="bad-response-feedback"
          label="How could this response be improved?"
          value={comment}
          onChange={(event) => setComment(event.target.value)}
          rows={4}
        />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button onClick={() => void handleSubmit()} disabled={isSubmitting} isBusy={isSubmitting}>
            Submit feedback
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
